import { useEffect, useState } from 'react'

import { SnackbarConfigTypes } from '../commons/utils/Types'
import * as FeatureFlagsAPI from './API/FeatureFlagsAPI'
import { FeatureFlagItem } from './API/FeatureFlagsAPI'
import FeatureFlagsView from './FeatureFlagsView'

export default function FeatureFlagsContainer() {
    const [flags, setFlags] = useState<FeatureFlagItem[]>([])
    const [isLoading, setIsLoading] = useState(true)
    const [flagToEdit, setFlagToEdit] = useState<FeatureFlagItem | null>(null)
    const [isFormOpen, setIsFormOpen] = useState(false)
    const [snackbarConfig, setSnackBarConfig] = useState<SnackbarConfigTypes>({
        message: '',
        isVisible: false,
        status: 'success',
    })

    async function fetchFlags() {
        try {
            setIsLoading(true)
            const response = await FeatureFlagsAPI.getFeatureFlags()
            setFlags(response.data ?? [])
        } catch {
            setSnackBarConfig({
                message: 'Erro ao buscar feature flags',
                isVisible: true,
                status: 'error',
            })
        } finally {
            setIsLoading(false)
        }
    }

    useEffect(() => {
        fetchFlags()
    }, [])

    const handleTogglePlatform = async (
        flag: FeatureFlagItem,
        platform: 'app' | 'web'
    ) => {
        const current: FeatureFlagsAPI.PlatformOverride = flag[platform] ?? {}
        const nextEnabled = !(current.enabled ?? flag.enabled ?? true)
        try {
            const data: Partial<FeatureFlagsAPI.FeatureFlag> = {
                [platform]: { ...current, enabled: nextEnabled },
            }
            await FeatureFlagsAPI.updateFeatureFlag(flag.documentId, data)
            const response = await FeatureFlagsAPI.getFeatureFlags()
            setFlags(response.data ?? [])
        } catch {
            setSnackBarConfig({
                message: 'Erro ao atualizar feature flag',
                isVisible: true,
                status: 'error',
            })
        }
    }

    const handleSave = async (data: FeatureFlagsAPI.FeatureFlag) => {
        if (!flagToEdit) return
        try {
            await FeatureFlagsAPI.updateFeatureFlag(flagToEdit.documentId, data)
            setFlags((prev) =>
                prev.map((f) =>
                    f.documentId === flagToEdit.documentId
                        ? { ...f, ...data }
                        : f
                )
            )
            setIsFormOpen(false)
            setFlagToEdit(null)
            setSnackBarConfig({
                message: 'Feature flag atualizada com sucesso',
                isVisible: true,
                status: 'success',
            })
        } catch {
            setSnackBarConfig({
                message: 'Erro ao salvar feature flag',
                isVisible: true,
                status: 'error',
            })
        }
    }

    return (
        <FeatureFlagsView
            flags={flags}
            isLoading={isLoading}
            snackbarConfig={snackbarConfig}
            flagToEdit={flagToEdit}
            isFormOpen={isFormOpen}
            onCloseSnackbar={() =>
                setSnackBarConfig((prev) => ({ ...prev, isVisible: false }))
            }
            onTogglePlatform={handleTogglePlatform}
            onEdit={(flag) => {
                setFlagToEdit(flag)
                setIsFormOpen(true)
            }}
            onFormClose={() => {
                setIsFormOpen(false)
                setFlagToEdit(null)
            }}
            onSave={handleSave}
        />
    )
}
